import { TdsAlert, TdsButton, TdsButtonContainer, TdsCheck } from '@trv-tds/react';
import { GlobalContext } from 'context/GlobalProvider';
import _map from 'lodash/map';
import React, { useContext, useEffect, useState } from 'react';
import { Stepper } from '../../components/shared';
import { useReloadRedirect } from '../../hooks';
import { STEPPER_TEXT, STEP_STATUS } from '../../utils/constants';
import { metricsElementTag, metricsPage, metricsPageViewTag } from '../../utils/coremetrics';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import ScrollToTop from '../../components/shared/ScrollToTop';

const steps = [
    {
        progress: STEP_STATUS.CURRENT,
        text: STEPPER_TEXT.FIRST_STEP
    },
    {
        progress: STEP_STATUS.INCOMPLETE,
        text: STEPPER_TEXT.SECOND_STEP
    },
    {
        progress: STEP_STATUS.INCOMPLETE,
        text: STEPPER_TEXT.THIRD_STEP
    },
    {
        progress: STEP_STATUS.INCOMPLETE,
        text: STEPPER_TEXT.FOURTH_STEP
    }
];

export default function ConfirmPolicies() {
    const {
        state: { policyTerms }
    } = useContext(GlobalContext);
    const [confirmCorrect, setConfirmCorrect] = useState(null);
    const [continueClicked, setContinueClicked] = useState(false);
    const navigate = useNavigate();

    function confirmCorrectChange(event) {
        setConfirmCorrect(event.target.value);
    }

    useReloadRedirect();

    useEffect(() => {
        metricsPageViewTag(metricsPage.confirmPolicy);
    }, []);

    function continueClick() {
        metricsElementTag(metricsPage.confirmPolicy, false);
        setContinueClicked(true);
        if (confirmCorrectValid()) {
            if (confirmCorrect === 'true') {
                navigate('/contact-info');
            } else {
                navigate('/call-us');
            }
        }
    }

    function confirmCorrectValid() {
        return confirmCorrect !== null;
    }

    function showConfirmCorrectError() {
        return !confirmCorrectValid() && continueClicked;
    }

    return (
        <div className="confirm-policies">
            <ScrollToTop />
            <Stepper steps={steps}></Stepper>
            <h1 data-testid="confirm-policies-header" className="tds-h1--article reg-header center">
                Confirm Policies
            </h1>
            <form>
                <div className="tds-row tds-justify-content-center">
                    <div className="tds-col-lg-12">
                        <table className="tds-data-table policies-table">
                            <caption className="page-caption">
                                Our records indicate that you have access to the following policies:
                            </caption>
                            <thead>
                                <tr>
                                    <th data-testid="insured-name-header-cell">Insured Name</th>
                                    <th data-testid="policy-nbr-header-cell">Policy Number</th>
                                    <th data-testid="policy-term-header-cell">Policy Term</th>
                                </tr>
                            </thead>
                            <tbody>
                                {_map(
                                    policyTerms,
                                    (
                                        { insuredNm, policyFormCd, policyNbr, formattedPolicyTerm },
                                        index
                                    ) => (
                                        <tr key={policyFormCd + policyNbr + formattedPolicyTerm}>
                                            <td
                                                className={'policy-details'}
                                                data-testid={'insured-name-body-cell' + index}
                                            >
                                                {insuredNm}
                                            </td>
                                            <td
                                                className={'policy-details'}
                                                data-testid={'policy-nbr-body-cell' + index}
                                            >
                                                {policyFormCd} - {policyNbr}
                                            </td>
                                            <td
                                                className={'policy-details'}
                                                data-testid={'policy-term-body-cell' + index}
                                            >
                                                {formattedPolicyTerm}
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="tds-row tds-flex tds-justify-content-center select-answer">
                    <div className="tds-col-12">
                        <fieldset
                            role="group"
                            className={
                                showConfirmCorrectError()
                                    ? 'confirm-correct tds-check-group--error'
                                    : 'confirm-correct'
                            }
                            aria-labelledby="confirm-correct-text"
                            aria-describedby="confirm-correct-error-message"
                            aria-invalid={showConfirmCorrectError()}
                            data-testid="confirm-correct-fieldset"
                        >
                            <p
                                className="confirm-correct-text"
                                id="confirm-correct-text"
                                data-testid="confirm-correct-text"
                            >
                                Is this correct?
                            </p>
                            <TdsCheck
                                type="radio"
                                name="confirm-correct"
                                value="true"
                                onTdsChange={confirmCorrectChange}
                                data-testid="confirm-correct-yes"
                            >
                                Yes
                            </TdsCheck>
                            <TdsCheck
                                type="radio"
                                name="confirm-correct"
                                value="false"
                                onTdsChange={confirmCorrectChange}
                                data-testid="confirm-correct-no"
                            >
                                No
                            </TdsCheck>
                            <TdsAlert
                                id="confirm-correct-error-message"
                                data-testid="confirm-correct-error-message"
                                type="error"
                                className={showConfirmCorrectError() ? '' : 'tds-d-none'}
                                inline
                            >
                                Please select one.
                            </TdsAlert>
                        </fieldset>
                    </div>
                </div>
                <TdsButtonContainer class="button-container-fix">
                    <TdsButton variant="primary" onClick={continueClick}>
                        Continue
                    </TdsButton>
                </TdsButtonContainer>
            </form>
        </div>
    );
}
